import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Tooltip,
  Typography,
  Radio,
  Modal,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { Grid } from "@material-ui/core";
import CustomModal from "../../components/common/customModal";
import CustomInput from "../../components/common/inputField";
import CustomSelect from "../../components/common/customSelect";
import CloseIcon from "@mui/icons-material/Close";
import {
  IdeaCapturinfFormData,
  IdeaCapturinfFormErrors,
  IdeathonQuestionsData,
  REImagingUpdateData,
} from "../../types/dashboard";
import dashboardService from "../../services/DashboardServices";
import { showToast } from "../../components/common/toastNotification";
import { ReimagineStatusEnum } from "../../helper/typeEnum";

interface IdeaCapturingModalProps {
  open: boolean;
  onClose: () => void;
  reImagineUpdateData: REImagingUpdateData;
}

interface OtherDetail {
  id: number;
  value: string;
}

interface Option {
  label: string;
  value: string;
}
const ReImagineAccessModal: React.FC<IdeaCapturingModalProps> = ({
  open,
  onClose,
  reImagineUpdateData,
}) => {
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [delegateLoading, setDelegateLoading] = useState(false);

  const [subFunctionOptions, setSubFunctionOptions] = useState<Option[]>([]);
  const [divisionOptions, setDivisionOptions] = useState<Option[]>([]);
  const [functionOptions, setFunctionOptions] = useState<Option[]>([]);
  const [approvalData, setApprovalData] = useState<Option[]>([]);
  const [otherDetailsCheckBoxData, setOtherDetailsCheckBoxData] = useState<
    OtherDetail[]
  >([]);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [remarksToastShown, setRemarksToastShown] = useState(false);

  const [formData, setFormData] = useState<IdeaCapturinfFormData>({
    id: null,
    division: "",
    departmentId: "",
    subFunctionName: "",
    approvalId: "",
    departmentIdReadOnly: "",
    approvalIdReadOnly: "",
    otherDetailsId: "",
    referenceDocument: "",
    remarks: "",
    ideaDetails: "",
    status: "",
    approverName: "",
    selectedDivision: "",
    selectDepartmentId: "",
    selectSubFunctionName: "",
    selectApprovalId: "",
    otherDetailsText: "",
  });

  const [formErrors, setFormErrors] = useState<IdeaCapturinfFormErrors>({
    selectDepartmentId: "",
    approvalId: "",
    otherDetailsId: "",
    referenceDocument: "",
    remarks: "",
    ideaDetails: "",
    selectedDivision: "",
    selectSubFunctionName: "",
    selectApprovalId: "",
  });
  const [is_Ideathon, setIsIdeathon] = useState(false);
  const [selectedFuncation, setSelectedFuncation] = useState("");
  const [ideathonQuestionsData, setIdeathonQuestionsData] = useState<
    IdeathonQuestionsData[]
  >([]);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);

  useEffect(() => {
    if (open) {
      if (Object.keys(reImagineUpdateData).length > 0) {
        setFormData({
          id: reImagineUpdateData.id ?? null,
          division: reImagineUpdateData.division || "",
          departmentId: reImagineUpdateData.functionName || "",
          subFunctionName: reImagineUpdateData.subFunctionName || "",
          approvalId: reImagineUpdateData.approvalId || "",
          departmentIdReadOnly: reImagineUpdateData.departmentId || "",
          approvalIdReadOnly: reImagineUpdateData.approvalId || "",
          otherDetailsId: reImagineUpdateData.otherDetailsId || "",
          referenceDocument: reImagineUpdateData.referenceDocument || "",
          remarks: reImagineUpdateData.remarks || "",
          ideaDetails: reImagineUpdateData.ideaDetails || "",
          status: reImagineUpdateData.status || "",
          approverName: reImagineUpdateData.approverName || "",
          otherDetailsText: reImagineUpdateData.otherData || "",
        });
        setSelectedFuncation(reImagineUpdateData.functionName || "");
        setIsIdeathon(Boolean(reImagineUpdateData.isIdeathon));
        setIdeathonQuestionsData(reImagineUpdateData.ideathonData || []);
      } else {
        setFormData({
          id: null,
          division: "",
          departmentId: "",
          selectedDivision: "",
          selectDepartmentId: "",
          selectSubFunctionName: "",
          subFunctionName: "",
          approvalId: "",
          departmentIdReadOnly: "",
          approvalIdReadOnly: "",
          otherDetailsId: "",
          referenceDocument: "",
          remarks: "",
          ideaDetails: "",
          approverName: "",
          status: "",
        });
      }

      setFormErrors({
        selectDepartmentId: "",
        approvalId: "",
        otherDetailsId: "",
        referenceDocument: "",
        remarks: "",
        ideaDetails: "",
        selectedDivision: "",
        selectSubFunctionName: "",
      });
    }
  }, [reImagineUpdateData, open]);

  useEffect(() => {
    fetchOtherDetailsCheckBoxData();
    fetchDivisions();
  }, []);

  const handleCheckboxChange2 = () => {
    setIsCheckboxChecked((prev) => !prev);
  };
  // fetch other details checkbox data
  const fetchOtherDetailsCheckBoxData = async () => {
    try {
      const response = await dashboardService.GetOtherDetailsAPI();

      if (response?.data?.data.length > 0) {
        const formattedData: OtherDetail[] = response.data.data.map(
          (item: { id: number; otherDetailsName: string }) => ({
            id: item.id,
            value: item.otherDetailsName,
          })
        );
        setOtherDetailsCheckBoxData(formattedData);
      } else {
        setOtherDetailsCheckBoxData([]);
      }
    } catch (error) {
      console.error("Error fetching other details:", error);
    }
  };

  // fetch Department list data
  const fetchFunctions = async (division: string) => {
    try {
      const { data } = await dashboardService.GetFunctionListByDivisionIdAPI(
        division
      );
      if (data?.success) {
        setFunctionOptions(
          (data.data as Array<Record<string, string>>)?.map((item) => ({
            label: item.functionName,
            value: item.functionName,
          })) || []
        );
      }
    } catch (error) {
      console.error("Failed to fetch functions", error);
    }
  };

  // fetch divistion list list data
  const fetchDivisions = async () => {
    try {
      const { data } = await dashboardService.getDivisionListAPI();
      if (data?.success) {
        setDivisionOptions(
          (data.data as Array<Record<string, string>>)?.map((item) => ({
            label: item.division,
            value: item.division,
          })) || []
        );
      }
    } catch (error) {
      console.error("Failed to fetch divisions", error);
    }
  };

  const fetchSubFunctions = async (func: string) => {
    try {
      const { data } = await dashboardService.GetSubFunctionByFunctionAPI(func);
      if (data?.success) {
        setSubFunctionOptions(
          (data.data as Array<Record<string, string>>)?.map((item) => ({
            label: item.subFunctionName,
            value: item.subFunctionName,
          })) || []
        );
      }
    } catch (error) {
      console.error("Failed to fetch sub-functions", error);
    }
  };

  const fetchApprovals = async (subFunction: string) => {
    try {
      const { data } = await dashboardService.GetApprovalNameBySubFunctionAPI(
        subFunction
      );
      if (data?.success) {
        const approvalOptions = (
          data.data as Array<Record<string, string>>
        )?.map((item) => ({
          label: `${item.approvalName}(${item.approvalEmail})`,
          value: item.approvalId,
        }));

        setApprovalData(approvalOptions);
        return approvalOptions;
      }
    } catch (error) {
      console.error("Error fetching approval list:", error);
    }

    return [];
  };
  //// handle Input Onchange code
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name === "remarks") {
      if (value.length > 255) {
        if (!remarksToastShown) {
          showToast("Reason cannot exceed 255 characters.", "error");
          setRemarksToastShown(true);
        }
        return;
      } else {
        if (remarksToastShown) {
          setRemarksToastShown(false);
        }
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  /// hande Drop down onchange code
  const handleDropDownOnChange = async (event: {
    target: { name: string; value: string | number };
  }) => {
    const { name, value } = event.target;

    if (name === "selectedDivision") {
      setFormData((prev) => ({
        ...prev,
        selectedDivision: value.toString(),
        selectDepartmentId: "",
        selectSubFunctionName: "",
        selectApprovalId: "",
      }));
      setFunctionOptions([]);
      setSubFunctionOptions([]);
      setApprovalData([]);
      await fetchFunctions(value.toString());
    } else if (name === "selectDepartmentId") {
      if (selectedFuncation !== value.toString()) {
        setFormData((prev) => ({
          ...prev,
          selectDepartmentId: value.toString(),
          selectSubFunctionName: "",
          selectApprovalId: "",
        }));
        setSubFunctionOptions([]);
        setApprovalData([]);
        await fetchSubFunctions(value.toString());
      } else {
        showToast("You cannot delegate to the same function.", "error");
      }
    } else if (name === "selectSubFunctionName") {
      setFormData((prev) => ({
        ...prev,
        selectSubFunctionName: value.toString(),
        selectApprovalId: "",
      }));
      setApprovalData([]);

      const approvals = await fetchApprovals(value.toString());
      if (approvals.length > 0) {
        setFormData((prev) => ({
          ...prev,
          selectApprovalId: approvals[0].value,
        }));
      }
    }

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  //// handle form validation code
  const validateForm = () => {
    const errors: IdeaCapturinfFormErrors = {};
    if (isCheckboxChecked) {
      if (!formData.selectedDivision) {
        errors.selectedDivision = "Division is required.";
      }
      if (!formData.selectDepartmentId) {
        errors.selectDepartmentId = "Function is required.";
      }
      if (!formData.selectSubFunctionName) {
        errors.selectSubFunctionName = "Sub Function is required.";
      }
      if (!formData.selectApprovalId) {
        errors.selectApprovalId = "Approval By is required.";
      }
    }

    if (rejectModalOpen) {
      const raw = formData.remarks || "";

      if (raw.trim() === "") {
        const msg = "Reason is required.";
        errors.remarks = msg;
      } else if (raw.length > 254) {
        const msg = "Reason cannot exceed 255 characters.";
        errors.remarks = msg;
      }
    }

    setFormErrors({
      selectedDivision: errors.selectedDivision || "",
      selectDepartmentId: errors.selectDepartmentId || "",
      selectSubFunctionName: errors.selectSubFunctionName || "",
      referenceDocument: errors.referenceDocument || "",
      remarks: errors.remarks || "",
      ideaDetails: errors.ideaDetails || "",
      selectApprovalId: errors.selectApprovalId || "",
    });

    return Object.keys(errors).length === 0;
  };

  const handleSaveFormData = async (
    status: ReimagineStatusEnum,
    setLoading: (loading: boolean) => void
  ) => {
    if (!validateForm()) return;

    try {
      setLoading(true);
      const {
        id,
        remarks,
        selectedDivision,
        selectDepartmentId,
        selectSubFunctionName,
        selectApprovalId,
      } = formData;

      const inputData = {
        id,
        division: selectedDivision,
        functionName: selectDepartmentId,
        subFunctionName: selectSubFunctionName,
        approvalId: selectApprovalId,
        status,
        remark: remarks,
      };

      const response = await dashboardService.addREImagineAccessAPI(inputData);

      if (response && response.data) {
        setRejectModalOpen(false);
        showToast(response.data.message, "success");
        setFormData({
          id: null,
          division: "",
          departmentId: "",
          subFunctionName: "",
          approvalId: "",
          departmentIdReadOnly: "",
          approvalIdReadOnly: "",
          otherDetailsId: "",
          referenceDocument: "",
          remarks: "",
          ideaDetails: "",
          status: "",
          remarkReason: "",
          selectApprovalId: "",
        });
        onClose();
      } else {
        showToast(response?.data?.message || "Something went wrong", "error");
      }
    } catch (error) {
      setRejectModalOpen(false);
      console.error("Error:", error);
      showToast("Error submitting data", "error");
    } finally {
      setLoading(false);
      setRejectModalOpen(false);
    }
  };

  return (
    <>
      <CustomModal
        open={open}
        isSaveButtonShow={false}
        onSave={() => {}}
        handleClose={onClose}
        title="Idea capturing platform"
        width={800}
        // btnLoading={btnLoading}
      >
        <Box>
          <Typography className="f-14" mb={1} color="error" fontWeight={600}>
            Employee Details{" "}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "medium", fontSize: "12px", display: "flex" }}
              >
                Full Name
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "500",
                  fontSize: "12px",
                  display: "flex",
                  color: "#CCCCCC",
                }}
              >
                {reImagineUpdateData.createdByName}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "medium", fontSize: "12px", display: "flex" }}
              >
                Employee Code
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "500",
                  fontSize: "12px",
                  display: "flex",
                  color: "#CCCCCC",
                }}
              >
                {" "}
                {reImagineUpdateData.createdBy}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "medium", fontSize: "12px", display: "flex" }}
              >
                Function Name
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "500",
                  fontSize: "12px",
                  display: "flex",
                  color: "#CCCCCC",
                }}
              >
                {reImagineUpdateData.userFunction}
              </Typography>
            </Grid>
          </Grid>

          <Typography
            className="f-14"
            mb={1}
            color="error"
            fontWeight={600}
            mt={1}
          >
            {is_Ideathon ? "Your Idea" : "Impact Areas"}
          </Typography>

          {is_Ideathon ? (
            <Grid container spacing={2}>
              {ideathonQuestionsData.map((item) => (
                <Grid item xs={12} key={item.id}>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 500, mb: 0.5, color: "#fff" }}
                  >
                    {item.question}
                  </Typography>
                  <CustomInput
                    name={item.answer}
                    placeholder="Write Answer"
                    type="text"
                    value={item.answer}
                    onChange={() => {}}
                    readOnly={true}
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid container spacing={2}>
              {otherDetailsCheckBoxData.map((item) => (
                <Grid item xs={12} sm={6} key={item.id}>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={formData.otherDetailsId.includes(
                          item.id.toString()
                        )}
                        onChange={() => {}}
                        sx={{
                          padding: "5px 10px",
                          color: "#FFFFFF",
                          "&.Mui-checked": {
                            color: "red",
                          },
                        }}
                      />
                    }
                    className="f-12"
                    label={item.value}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      width: "100%",
                      "& .MuiFormControlLabel-label": {
                        fontSize: "12px",
                        flex: 1,
                      },
                    }}
                  />
                </Grid>
              ))}
              {Array.isArray(formData.otherDetailsId) &&
                formData.otherDetailsId.includes("10") && (
                  <Grid item xs={12} style={{ marginTop: "10px" }}>
                    <CustomInput
                      name="otherDetailsText"
                      placeholder="Please specify your impact area"
                      type="text"
                      value={formData.otherDetailsText}
                      onChange={handleInputChange}
                      error={formErrors.otherDetailsText}
                      readOnly={true}
                    />
                  </Grid>
                )}
            </Grid>
          )}

          <Grid container spacing={2} style={{ marginTop: "8px" }}>
            {!is_Ideathon && (
              <>
                <Typography
                  className="f-14"
                  mb={1}
                  ml={1}
                  color="error"
                  fontWeight={600}
                  mt={1}
                >
                  Your Idea
                </Typography>
                <Grid item xs={12}>
                  <CustomInput
                    label=""
                    name="ideaDetails"
                    placeholder="Enter the Detail about your idea"
                    type="text"
                    onChange={handleInputChange}
                    value={formData.ideaDetails}
                    error={formErrors.ideaDetails}
                    readOnly={true}
                    required
                  />
                </Grid>
              </>
            )}
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography
              className="f-14"
              mb={1}
              color="error"
              fontWeight={600}
              mt={1}
            >
              Reference Document (If Any)
            </Typography>
            <Grid item xs={12}>
              {formData.referenceDocument ? (
                <a
                  href={formData.referenceDocument}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "underline", color: "#1976d2" }}
                >
                  {formData.referenceDocument}
                </a>
              ) : (
                <span>-</span>
              )}
            </Grid>
          </Grid>
          {!is_Ideathon && Number(formData.status) === 1 && (
            <Grid
              item
              xs={12}
              sm={12}
              style={{ marginTop: "8px", marginBottom: "8px" }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isCheckboxChecked}
                    onChange={handleCheckboxChange2}
                    sx={{
                      padding: "5px 10px",
                      color: "#FFFFFF",
                      "&.Mui-checked": {
                        color: "red",
                      },
                    }}
                  />
                }
                className="f-14"
                label="I want to delegate this request to other department"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  width: "100%",
                  "& .MuiFormControlLabel-label": {
                    fontSize: "12px",
                    flex: 1,
                  },
                }}
              />
            </Grid>
          )}
          {isCheckboxChecked && (
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <CustomSelect
                  name="selectedDivision"
                  label="Division"
                  placeHolder="Select Division"
                  onChange={handleDropDownOnChange}
                  options={divisionOptions}
                  value={formData.selectedDivision || ""}
                  error={formErrors.selectedDivision}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomSelect
                  name="selectDepartmentId"
                  label="Function Name"
                  placeHolder="Select Function"
                  onChange={handleDropDownOnChange}
                  options={functionOptions}
                  value={formData.selectDepartmentId || ""}
                  error={formErrors.selectDepartmentId}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomSelect
                  name="selectSubFunctionName"
                  label="Sub Function"
                  placeHolder="Select Sub Function"
                  onChange={handleDropDownOnChange}
                  options={subFunctionOptions}
                  value={formData.selectSubFunctionName || ""}
                  error={formErrors.selectSubFunctionName}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomSelect
                  name="selectApprovalId"
                  label="Approval"
                  placeHolder="Select Approval"
                  onChange={handleDropDownOnChange}
                  options={approvalData}
                  value={formData.selectApprovalId || ""}
                  error={formErrors.selectApprovalId}
                  required
                  readOnly
                />
              </Grid>
            </Grid>
          )}
          {is_Ideathon ? (
            <>
              {(Number(formData.status) == 1 ||
                Number(formData.status) == 4) && (
                <Box display="flex" justifyContent="center" gap={2} mt={3}>
                  <Button
                    fullWidth
                    variant="contained"
                    className="saveBtn"
                    style={{
                      borderRadius: "0px",
                      background: "#393939",
                      maxWidth: "140px",
                      marginLeft: "20px",
                    }}
                    onClick={() => setRejectModalOpen(true)}
                  >
                    <Typography> Reject</Typography>
                  </Button>

                  <Button
                    fullWidth
                    variant="contained"
                    className="saveBtn"
                    disabled={approveLoading}
                    style={{
                      borderRadius: "0px",
                      background: "#393939",
                      maxWidth: "140px",
                    }}
                    onClick={() =>
                      handleSaveFormData(
                        ReimagineStatusEnum.Approved,
                        setApproveLoading
                      )
                    }
                  >
                    {approveLoading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <Typography>Approve</Typography>
                    )}
                  </Button>
                </Box>
              )}
            </>
          ) : (
            <Box display="flex" justifyContent="center" gap={2} mt={3}>
              {(Number(formData.status) == 1 ||
                Number(formData.status) == 4) && (
                <>
                  <Button
                    fullWidth
                    variant="contained"
                    className="saveBtn"
                    disabled={rejectLoading}
                    style={{
                      borderRadius: "0px",
                      background: "#393939",
                      maxWidth: "140px",
                      marginLeft: "20px",
                    }}
                    onClick={() => setRejectModalOpen(true)}
                  >
                    {rejectLoading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <Typography>Reject</Typography>
                    )}
                  </Button>

                  <Button
                    fullWidth
                    variant="contained"
                    className="saveBtn"
                    disabled={approveLoading}
                    style={{
                      borderRadius: "0px",
                      background: "#393939",
                      maxWidth: "140px",
                    }}
                    onClick={() =>
                      handleSaveFormData(
                        ReimagineStatusEnum.Approved,
                        setApproveLoading
                      )
                    }
                  >
                    {approveLoading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <Typography>Approve</Typography>
                    )}
                  </Button>
                </>
              )}

              {!isCheckboxChecked ? (
                <>
                  {!is_Ideathon && Number(formData.status) === 1 && (
                    <Tooltip
                      sx={{ marginLeft: "0px", fontSize: "14px" }}
                      title="The idea can be delegated only once"
                      arrow
                    >
                      <span>
                        <Button
                          fullWidth
                          variant="contained"
                          className="saveBtn"
                          disabled={delegateLoading}
                          style={{
                            borderRadius: "0px",
                            background: "#393939",
                            maxWidth: "140px",
                            minWidth: "140px",
                            // marginLeft: "20px",
                            cursor: !isCheckboxChecked
                              ? "not-allowed"
                              : "pointer",
                            opacity: !isCheckboxChecked ? 0.5 : 1,
                          }}
                          onClick={() =>
                            handleSaveFormData(
                              ReimagineStatusEnum.Delegate,
                              setDelegateLoading
                            )
                          }
                        >
                          {delegateLoading ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : (
                            <Typography>Delegate</Typography>
                          )}
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                </>
              ) : (
                <>
                  {!is_Ideathon && Number(formData.status) === 1 && (
                    <Tooltip
                      sx={{ marginLeft: "0px", fontSize: "14px" }}
                      title="The idea can be delegated only once"
                      arrow
                    >
                      <Button
                        fullWidth
                        variant="contained"
                        className="saveBtn"
                        disabled={delegateLoading}
                        style={{
                          borderRadius: "0px",
                          background: "#393939",
                          maxWidth: "140px",
                          // marginLeft: "20px",
                          opacity: 1,
                        }}
                        onClick={() =>
                          handleSaveFormData(
                            ReimagineStatusEnum.Delegate,
                            setDelegateLoading
                          )
                        }
                      >
                        {delegateLoading ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          <Typography>Delegate</Typography>
                        )}
                      </Button>
                    </Tooltip>
                  )}
                </>
              )}
            </Box>
          )}
        </Box>
      </CustomModal>
      <Modal
        open={rejectModalOpen}
        onClose={() => setRejectModalOpen(false)}
        sx={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "80%", md: 350 },
            bgcolor: "#393939",
            color: "#ffffff",
            boxShadow: 24,
            p: 1,
            borderRadius: "0px",
          }}
        >
          <IconButton
            onClick={() => setRejectModalOpen(false)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#fff",
            }}
          >
            <CloseIcon sx={{ color: "#E12013" }} />
          </IconButton>
          <Box sx={{ p: "28px 24px", textAlign: "left", fontSize: "14px" }}>
            <CustomInput
              label="Remarks"
              name="remarks"
              placeholder="Enter Remarks"
              type="text"
              onChange={handleInputChange}
              value={formData.remarks}
              error={formErrors.remarks}
              readOnly={false}
              required
            />
          </Box>

          <Box
            sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 3 }}
          >
            <Button
              variant="contained"
              className="saveBtn"
              disabled={rejectLoading}
              onClick={() =>
                handleSaveFormData(
                  ReimagineStatusEnum.Rejected,
                  setRejectLoading
                )
              }
              sx={{ width: "120px" }}
            >
              {rejectLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ReImagineAccessModal;
